import React, { useState, useEffect } from "react";
import { db } from "../../firebase-config";
import { useParams, Link } from "react-router-dom";
import { ref, onValue } from "firebase/database";
import { saveAs } from "file-saver";
import "./ViewSingleAdmin.css";
import "./ViewDetail";

function ViewSingleAdmin() {
  const [users, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [downloadingPatientId, setDownloadingPatientId] = useState(null);
  const [eventSource, setEventSource] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const usersRef = ref(db, `superadmin/admins/${id}`);
    onValue(usersRef, (snapshot) => {
      if (snapshot.exists()) {
        setUser({ ...snapshot.val() });
      } else {
        setUser({});
      }
    });
  }, [id]);

  const handleDownloadDicomData = async (patientId, patientName) => {
    setLoading(true);
    setProgress(0);
    setShowModal(true);
    setDownloadingPatientId(patientId); // Set the downloading patient ID

    const es = new EventSource(`http://localhost:5000/download_dicoms/${id}/${patientId}`);
    setEventSource(es);
    
    es.onmessage = function(event) {
      const data = JSON.parse(event.data);
      setProgress(Math.round(data.progress) || 0); // Round progress to the nearest integer
      if (data.message === "Download complete") {
        es.close();
        setLoading(false);
        setDownloadingPatientId(null); // Reset the downloading patient ID
        setEventSource(null);
        downloadFile(patientName);
      }
    };

    es.onerror = function(err) {
      console.error("EventSource failed:", err);
      es.close();
      setLoading(false);
      setDownloadingPatientId(null); // Reset the downloading patient ID in case of error
      setEventSource(null);
    };
  };

  const downloadFile = async (patientName) => {
    try {
      const response = await fetch('http://localhost:5000/download_dicoms_file');
      const blob = await response.blob();
      saveAs(blob, `${patientName}_dicom_data.zip`);
      setShowModal(false); // Hide the modal
    } catch (error) {
      console.error('Error downloading the final file:', error);
    }
  };

  const handleCloseModal = () => {
    if (eventSource) {
      eventSource.close();
    }
    setLoading(false);
    setShowModal(false);
    setDownloadingPatientId(null);
    setEventSource(null);
  };

  return (
    <>
      <div style={{ marginTop: "100px" }}>
        <h2 className="text-center adminlist">{users.FullName}</h2>
        <Link to="/SuperAdmin?section=viewAdmins" className="homeButton">
          <span id="backText" className="backText">Back</span>
          <i id="backIcon" className="fas fa-long-arrow-alt-left fa-lg fa-2x"></i>
        </Link>
        <div className="container div-viewSingleAdmin ">
          <div className="card-header">
            <strong>AdminName :</strong>
            <span className="admin-name">{users.FullName}</span>
            <hr />

            <strong>Doctors:</strong>
            {users &&
              users.doctors &&
              Object.keys(users.doctors).map((doctor, index) => (
                <div key={index}>
                  <span className="viewAllName"> {doctor}</span>
                </div>
              ))}

            <br />
            <strong>Patients:</strong>
            {users &&
              users.patients &&
              Object.keys(users.patients).map((patient, index) => (
                <div key={index} className="singleAdmin-download-patient-container">
                  <span className="viewAllName">{patient}</span>
                  <div className="tooltip-container">
                    <button
                      className={`singleAdmin-download-button ${(!users.patients[patient].FolderPath) ? 'disabled' : ''}`}
                      onClick={() => handleDownloadDicomData(patient, patient)}
                      disabled={(loading && downloadingPatientId === patient) || !users.patients[patient].FolderPath}
                    >
                      {loading && downloadingPatientId === patient ? `Downloading...` : "Download Dicom"}
                    </button>
                    {!users.patients[patient].FolderPath && (
                      <span className="tooltip-text">File Not Available</span>
                    )}
                  </div>
                </div>
              ))}
            <br />
            <strong>Technicians:</strong>
            {users &&
              users.technicians &&
              Object.keys(users.technicians).map((technician, index) => (
                <div key={index}>
                  <span className="viewAllName">{technician}</span>
                </div>
              ))}
            <br />
            <br />

            <Link to={"/SuperAdmin/ViewDetail" + id}>
              <button className="btn1 btn-view1">View Detail</button>
            </Link>

            <Link to="/SuperAdmin/ViewAll">
              <button className="backbutton">Back</button>
            </Link>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="singleAdmin-download-modal-overlay">
          <div className="singleAdmin-download-modal-content">
            <button className="singleAdmin-close-button" onClick={handleCloseModal}>×</button>
            <h2>Download Progress</h2>
            <div className="singleAdmin-download-progress-bar">
              <div className="singleAdmin-download-progress-bar-fill" style={{ width: `${progress}%` }}></div>
            </div>
            <h6>{progress}%</h6>
            <button className="singleAdmin-cancel-button" onClick={handleCloseModal}>Cancel</button>
          </div>
        </div>
      )}
    </>
  );
}

export default ViewSingleAdmin;






// BELOW IS CODE FOR DOWNLOADING THE DATA WITHOUT BACKEND SERVER, WORKING PERFECTLY FINE

// import React, { useState, useEffect } from "react";
// import { db } from "../../firebase-config";
// import { useParams, Link } from "react-router-dom";
// import { ref, onValue } from "firebase/database";
// import { getStorage, ref as storageRef, listAll, getDownloadURL } from "firebase/storage";
// import JSZip from "jszip";
// import { saveAs } from "file-saver";
// import "./ViewSingleAdmin.css";
// import "./ViewDetail";

// function ViewSingleAdmin() {
//   const [users, setUser] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [fileCount, setFileCount] = useState(0);
//   const [downloadedCount, setDownloadedCount] = useState(0);
//   const { id } = useParams();
//   const storage = getStorage();

//   useEffect(() => {
//     const usersRef = ref(db, `superadmin/admins/${id}`);
//     onValue(usersRef, (snapshot) => {
//       if (snapshot.exists()) {
//         setUser({ ...snapshot.val() });
//       } else {
//         setUser({});
//       }
//     });
//   }, [id]);

//   const downloadFile = async (fileRef, zip, basePath) => {
//     const url = await getDownloadURL(fileRef);
//     const response = await fetch(url);
//     const blob = await response.blob();
//     const relativePath = fileRef.fullPath.replace(basePath, '');
//     zip.file(relativePath, blob);
//     setDownloadedCount(prevCount => prevCount + 1); // Increment downloaded count
//   };

//   const handleDownloadDicomData = async (patientId) => {
//     setLoading(true);
//     setFileCount(0);
//     setDownloadedCount(0);

//     const patientRef = ref(db, `superadmin/admins/${id}/patients/${patientId}`);
//     onValue(patientRef, async (snapshot) => {
//       if (snapshot.exists()) {
//         const folderPath = snapshot.val().FolderPath;
//         const folderRef = storageRef(storage, folderPath);
//         const zip = new JSZip();
        
//         const listFiles = async (folderRef) => {
//           const { items, prefixes } = await listAll(folderRef);
//           const allFiles = [...items];
//           for (const prefix of prefixes) {
//             const nestedFiles = await listFiles(prefix);
//             allFiles.push(...nestedFiles);
//           }
//           return allFiles;
//         };

//         const allFiles = await listFiles(folderRef);
//         setFileCount(allFiles.length);

//         // Download all files in parallel
//         await Promise.all(allFiles.map(fileRef => downloadFile(fileRef, zip, folderPath)));

//         // Generate the zip file and trigger the download
//         zip.generateAsync({ type: "blob" }).then((content) => {
//           saveAs(content, "dicom_data.zip");
//           setLoading(false);
//         });
//       } else {
//         console.error('Folder path not found for patient:', patientId);
//         setLoading(false);
//       }
//     });
//   };

//   return (
//     <>
//       <div style={{ marginTop: "100px" }}>
//         <h2 className="text-center adminlist">{users.FullName}</h2>
//         <Link to="/SuperAdmin/ViewAll" className="homeButton">
//           <span id="backText" className="backText">Back</span>
//           <i id="backIcon" className="fas fa-long-arrow-alt-left fa-lg fa-2x"></i>
//         </Link>
//         <div className="container div-viewSingleAdmin ">
//           <div className="card-header">
//             <strong>AdminName :</strong>
//             <span className="admin-name">{users.FullName}</span>
//             <hr />

//             <strong>Doctors:</strong>
//             {users &&
//               users.doctors &&
//               Object.keys(users.doctors).map((doctor, index) => (
//                 <div key={index}>
//                   <span className="viewAllName"> {doctor}</span>
//                 </div>
//               ))}

//             <br />
//             <strong>Patients:</strong>
//             {users &&
//               users.patients &&
//               Object.keys(users.patients).map((patient, index) => (
//                 <div key={index}>
//                   <span className="viewAllName">{patient}</span>
//                   <button
//                     className="btn1 btn-view1"
//                     onClick={() => handleDownloadDicomData(patient)}
//                     disabled={loading}
//                   >
//                     {loading ? `Downloading... (${downloadedCount}/${fileCount} files)` : "Download DICOM Data"}
//                   </button>
//                 </div>
//               ))}
//             <br />
//             <strong>Technicians:</strong>
//             {users &&
//               users.technicians &&
//               Object.keys(users.technicians).map((technician, index) => (
//                 <div key={index}>
//                   <span className="viewAllName">{technician}</span>
//                 </div>
//               ))}
//             <br />
//             <br />

//             <Link to={"/SuperAdmin/ViewDetail" + id}>
//               <button className="btn1 btn-view1">View Detail</button>
//             </Link>

//             <Link to="/SuperAdmin/ViewAll">
//               <button className="backbutton">Back</button>
//             </Link>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default ViewSingleAdmin;
